import { render, staticRenderFns } from "./ConveniosCotas.vue?vue&type=template&id=8fd18050&scoped=true&"
import script from "./ConveniosCotas.vue?vue&type=script&lang=js&"
export * from "./ConveniosCotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd18050",
  null
  
)

export default component.exports